import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import global from '@/utils/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'

// import '../static/lib/UE/ueditor.config.js'
// import '../static/lib/UE/ueditor.all.js'
// import '../static/lib/UE/lang/zh-cn/zh-cn.js'
// import '../static/lib/UE/ueditor.parse.min.js'
// import '../static/lib/UE/themes/default/css/ueditor.css'
// import '../public/lib/UE/ueditor.config.js'
// import '../public/lib/UE/ueditor.all.js'
// import '../public/lib/UE/lang/zh-cn/zh-cn.js'
// import '../public/lib/UE/ueditor.parse.min.js'
// import '../public/lib/UE/themes/default/css/ueditor.css'
import "@/utils/cert"
import '@/style/index.css'
Vue.use(ElementUI, {
  size: 'small'
});
Vue.use(api);

Vue.prototype.global = global;

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js